import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from "prop-types"
import React from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

// import Select from "react-select"
import { createYoutubeShortVideo, updateYoutubeShortVideo } from "store/actions"

const YoutubeShortVideosModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()

  const handleValidSubmit = (e, v) => {
    const Update = {
      title: v?.title,
      video_id: v?.video_id,
    }
    if (updateData?._id) {
      dispatch(updateYoutubeShortVideo(Update, updateData?._id, onCloseClick))
    } else {
      const Create = {
        title: v?.title,
        video_id: v?.video_id,
      }

      dispatch(createYoutubeShortVideo(Create, onCloseClick))
    }
  }
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id
            ? "Edit Video"
            : "Add Video"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="col-12 mb-2">
                <label>Title</label>
                <AvField
                  name="title"
                  type="text"
                  placeholder="Enter Title "
                  value={updateData?.title}
                  // validate={{
                  //   required: {
                  //     value: true,
                  //     errorMessage: "Title is required",
                  //   },
                  // }}
                />
              </Col>
            </>
          </Row>
          <Row>
            <Col className="col-12 mt-1">
              <label>
                Video Id <span className="text-danger"> *</span>
              </label>
              <AvField
                // label="Message"
                name="video_id"
                type="textarea"
                placeholder="Enter video id "
                value={updateData?.video_id}
                validate={{
                  required: {
                    value: true,
                    errorMessage: " video id is required",
                  },
                  // minLength: {
                  //   value: 10,
                  //   errorMessage: " number must be 10 letter ",
                  // },
                  // maxLength: {
                  //   value: 10,
                  //   errorMessage: "what's app number must be 10 letter ",
                  // },
                }}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

YoutubeShortVideosModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default YoutubeShortVideosModal
